// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q2/2026hygiene/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const postvote = (data: any) => {
  const qsData = qs.stringify(data);
  const unionid = localStorage.getItem('unionid');
  if (!unionid) return http.post(`${urlPrefix}vote`, qsData);
  return http.post(`${urlPrefix}vote&unionid=${unionid}`, qsData);
};

const getRank = () => {
  return http.get(`${urlPrefix}rank`);
};

const getVoteList = () => {
  return http.get(`${urlPrefix}vote-list`);
};
const canVote = () => {
  const unionid = localStorage.getItem('unionid');

  return http.get(`${urlPrefix}can-vote&unionid=${unionid}`);
};
export { getBaseInfo, getRank, postvote, getVoteList, canVote };
